import { cn } from '@/lib/utils';

/**
 * Skeleton para conteúdo estruturado. Reserva espaço com a MESMA altura do
 * conteúdo real — o estado de carregando não pode causar layout shift.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-chip bg-bg-subtle', className)} {...props} />;
}
